import styled from "styled-components/macro";

const starLoading = `
  animation: starPulse 1.2s ease-in-out infinite;

  @keyframes starPulse {
    0% {
      opacity: 0.35;
    }
    50% {
      opacity: 0.7;
    }
    100% {
      opacity: 0.35;
    }
  }
`;

export const SingleStar = styled.div`
  padding: 0px 4px;
  z-index: 99;
  position: relative;
  svg path {
    fill: ${(props) => (props.$loading ? "rgba(255, 56, 92, 0.18)" : props.isOn ? props.theme.colors.red : "rgba(255, 56, 92, 0.25)")};
    transition: 0.5s ease;
    ${(props) => (props.$loading ? starLoading : "")}
  }
`;

export const KanbanStars = styled.div`
  height: 16px;
  margin-top: 10px;
  background-color: transparent;
  border-radius: 15px;
  display: flex;
  align-items: center;
  cursor: ${(props) => (props.disabled || props.$loading ? "default" : "pointer")};
  margin-left: -3px;
  z-index: 98;
  position: relative;
  ${(props) => props.$loading && `opacity: 0.9;`}

  span {
    display: flex;
    z-index: 2;
  }
`;
